import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { PagePropsContext } from '../App';
import { getTextLink, getTextNoLink } from '../utils/functions';

const Footer = () => {
  const { t } = useTranslation();
  const { setShowContact } = useContext(PagePropsContext);

  return <div className='footer'>
    <p>
      {getTextNoLink(t('help.info'))[0]}
      <button className='button button--link' onClick={() => setShowContact(true)}>{getTextLink(t('help.info'))}</button>
      {getTextNoLink(t('help.info'))[1]}
    </p>
  </div>;
}

export default Footer;